// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../reason/next/Next.bs.js");
var React = require("react");
var Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ClosedChapterOverlay = require("../reason/common/ClosedChapterOverlay/ClosedChapterOverlay.bs.js");
var TerminatedAccountOverlay = require("../reason/common/TerminatedAccountOverlay/TerminatedAccountOverlay.bs.js");

function AuthenticatedComponentRelay(props) {
  var loaderComponent = props.loaderComponent;
  var redirectPath = props.redirectPath;
  var requiredUserRole = props.requiredUserRole;
  var initState = UserSession.useInitState();
  var router = Next.useRouter();
  React.useEffect((function () {
          switch (initState) {
            case "Unauthenticated" :
                var nextPath = Next.Router.asPath(router);
                var tmp = nextPath === "/" ? undefined : Object.fromEntries([[
                          "next",
                          nextPath
                        ]]);
                router.push({
                      pathname: "/login",
                      query: tmp
                    });
                break;
            case "Agent" :
                if (requiredUserRole === "client") {
                  Next.Router.push(Core__Option.getOr(redirectPath, "/"), undefined, undefined, router);
                }
                break;
            case "Client" :
                if (requiredUserRole === "agent") {
                  Next.Router.push(Core__Option.getOr(redirectPath, "/client"), undefined, undefined, router);
                }
                break;
            default:
              
          }
        }), [
        initState,
        requiredUserRole,
        Next.Router.pathname(router),
        Next.Router.query(router)
      ]);
  switch (initState) {
    case "Loading" :
        if (loaderComponent !== undefined) {
          return Caml_option.valFromOption(loaderComponent);
        } else {
          return JsxRuntime.jsx(Loader.make, {});
        }
    case "Agent" :
        if (requiredUserRole !== undefined) {
          if (requiredUserRole !== "agent" && requiredUserRole !== undefined) {
            return null;
          }
          
        } else if (requiredUserRole !== undefined) {
          return null;
        }
        break;
    case "Client" :
        if (requiredUserRole !== undefined) {
          if (requiredUserRole !== "client" && requiredUserRole !== undefined) {
            return null;
          }
          
        } else if (requiredUserRole !== undefined) {
          return null;
        }
        break;
    default:
      return null;
  }
  var tmp;
  switch (initState) {
    case "Agent" :
        tmp = "Agent";
        break;
    case "Client" :
        tmp = "Client";
        break;
    default:
      tmp = undefined;
  }
  var tmp$1;
  tmp$1 = initState === "Agent" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(TerminatedAccountOverlay.make, {}),
            JsxRuntime.jsx(ClosedChapterOverlay.make, {})
          ]
        }) : null;
  return JsxRuntime.jsxs(UserSession.AuthenticatedStateProvider.make, {
              value: tmp,
              children: [
                tmp$1,
                props.renderWrappedComponent()
              ]
            });
}

var make = AuthenticatedComponentRelay;

exports.make = make;
/* Next Not a pure module */
